import { useI18n } from "../i18n";
export type ReferenceQuote = {
  service: string; region: string; instance_type?: string; price_model?: string;
  operating_system: string; tenancy?: string; purchase_option: string; currency: string; unit: string;
  hourly_usd?: string; effective_date: string; sku?: string; rate_code?: string;
  components?: { cpu: {usd_per_unit_hour: string}; memory: {usd_per_unit_hour: string} };
};
const priceText = (value?: string) => { if(value == null)return null;const [whole,tail=""]=value.split(".");return `USD ${whole.replace(/\B(?=(\d{3})+(?!\d))/g,",")}.${tail.replace(/0+$/,"").padEnd(2,"0")}`; };
export function ReferenceQuoteAmount({quote}:{quote?:ReferenceQuote|null}) {
  const {t}=useI18n();
  if (!quote) return <>{t("未定价","Unpriced")}</>;
  if (quote.price_model === "fargate_cpu_memory") return <><span>{priceText(quote.components?.cpu.usd_per_unit_hour)??t("未定价","Unpriced")} / vCPU·h</span><small>{priceText(quote.components?.memory.usd_per_unit_hour)??t("未定价","Unpriced")} / GiB·h</small></>;
  return <>{priceText(quote.hourly_usd)??t("未定价","Unpriced")} / {t("实例小时","instance-hour")}</>;
}
